import { render, staticRenderFns } from "./index.vue?vue&type=template&id=cff4b9ae&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=cff4b9ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cff4b9ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/s01-aiart-develop-cn/s01_haiyiai_develop-cn_aiart-web-openapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cff4b9ae')) {
      api.createRecord('cff4b9ae', component.options)
    } else {
      api.reload('cff4b9ae', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=cff4b9ae&scoped=true&", function () {
      api.rerender('cff4b9ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/403/index.vue"
export default component.exports